import type { NavigationItem } from '@umbraco/GetUmbracoNavigation';

// Feeds HeaderNavigation, the @gds/Header-based nav used only by the RAC whitelabel layout.
// @gds/Header expects `items` instead of `subnavgroupitems`, and only needs label/href/desc per
// item, hence the extra remap on top of what SanitizeNavigationItems.ts does for Drive's nav.
// Both utils are permanent: RAC and Drive have structurally different nav patterns (different
// mobile menu position, different dropdown interaction model) and are not being merged.
export const sanitizeNavigationItemsForHeader = (navigationItems: NavigationItem[]) => {
  return navigationItems.map(navItem => {
    const newSubNavGroups = navItem?.subNavGroups?.map(subNavGroup => ({
      heading: subNavGroup.heading,
      showAllLink: subNavGroup?.showAllLink?.[0] || null,
      items: subNavGroup.subnavgroupitems.map(item => ({
        label: item.label,
        href: item.href || item.link || '',
        desc: item.desc || item.description,
      })),
    }));
    return { ...navItem, subNavGroups: newSubNavGroups };
  });
};
